/**
 * The vocabulary of an application's progress, in one place.
 *
 * The order is information: a candidate moves forward through these stages, and
 * the two ways a process can end without reaching `hired` are not stages at
 * all. Keeping the sequence here means the rail and the filter agree about what
 * "further along" means, and the API's transition rules stay the authority.
 */
export const APPLICATION_STAGES = ['received', 'in_review', 'shortlisted', 'offered', 'hired'] as const;

export const APPLICATION_ENDINGS = ['rejected', 'withdrawn'] as const;

export const APPLICATION_STATUSES = [...APPLICATION_STAGES, ...APPLICATION_ENDINGS] as const;

export type ApplicationStatus = (typeof APPLICATION_STATUSES)[number];

/** A status as a person reads it: `in_review` is "In review". */
export function statusLabel(status: string): string {
  const words = status.replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}
